import { Project } from "./index";

export const RouteGetProjects_projectId_ = "/projects/:projectId";

export type ResponseGetProjects_projectId_ = Project;

export const RoutePutProjects_projectId_ = "/projects/:projectId";

export type PayloadPutProjects_projectId_ = Omit<Project, "project_id">;
